// "Expires in 23 hours" style labels, localised by Intl.

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['day', 24 * 60 * 60 * 1000],
  ['hour', 60 * 60 * 1000],
  ['minute', 60 * 1000],
];

/** The largest whole unit of time left (rounded down), at least 1 minute. */
export const timeLeft = (ms: number): { value: number; unit: Intl.RelativeTimeFormatUnit } => {
  for (const [unit, size] of UNITS) {
    if (ms >= size) return { value: Math.floor(ms / size), unit };
  }
  return { value: 1, unit: 'minute' };
};

/** e.g. "in 23 hours" (en). */
export const formatTimeLeft = (ms: number, locale: string): string => {
  const { value, unit } = timeLeft(ms);
  return new Intl.RelativeTimeFormat(locale, { numeric: 'always' }).format(value, unit);
};
